import React from 'react';
import { isEqual } from 'lodash';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { GET_VANPOOL_INFO, GET_VANPOOL_PARTICIPANTS, SET_REFRESH_DASHBOARD, UPDATE_USER_PROFILE_DATA, RESET_REFRESH_SUMMARY_API, LOAD_PROFILE_AFTER_PERSONALINFO_UPDATE, ENABLE_NEXT_BUTTON } from '../../redux/actionTypes';
import Loading from '../../shared/loading/Loading';
import { initialJoinCommuteState } from '../JoinCommuteReducer';
import OnboardingSlider from './OnboardingSlider';
import analyticsService from '../../shared/analytics/analytics-service';
import localStorageService from '../../shared/localStorageService'

function OnboardingPage(props) {

  const [enableNextButton, updateEnableNextButton] = useState(true);

  useEffect(() => {
    if (isEqual(props.joinCommuteData, initialJoinCommuteState)) {
      props.history.push("/JoinCommute");
    } else {
      props.getVanpoolInfo(props.history);
      props.getVanpoolParticipants(props.history);
      props.updateProfileData();
      //props.loadProfileData();
      props.setRefreshDashboard(true);
      analyticsService.pageInfo("customer onboarding");
    }
  }, []);

  function goToDashboard() {
    localStorageService.clear('inviteId');
    localStorageService.clear('leadFlow');
    props.updateEnableNextbutton(false);
    props.setRefreshDashboard(true);
    props.resetRefreshSummaryAPI(true);
    props.history.push('/dashboard');
    analyticsService.analyticsProcessEvent({
      "event": "add_profile_picture_click_done",
      "context": {
        "event_action": "done"  
      }
    });
  }

  useEffect(() => {
    if(props.employeeInfo && props.employeeInfo.isEmployeeIdRequired && !props.employeeInfo.employeeId && !props.enableOnboardingNextButton){
      updateEnableNextButton(false)
    }
  },[props.employeeInfo])

  useEffect(() => {
    if(props.employeeIdUpdated || props.employeeIdUpdatedFailed || props.enableOnboardingNextButton){
      updateEnableNextButton(true);
    }
},[props.employeeIdUpdated, props.employeeIdUpdatedFailed, props.enableOnboardingNextButton])

  return (
    <div className='onboarding-page'>
      <span aria-live='polite' role='alert'>
        <Loading isLoading={!props.vanInfoLoaded || !props.participantsInfoLoaded} />
      </span>
      <div className='onboarding-container'>
        <OnboardingSlider isPredelivery={props.isPredelivery} goToDashboard={goToDashboard} history={props.history} isDoneDisabled={(!props.uploadedImage && !props.uploadErrorOccurred)} employeeInfo={props.employeeInfo} enableNextButton={enableNextButton} />
      </div>
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    getVanpoolInfo(history) {
      dispatch({ type: GET_VANPOOL_INFO, history })
    },
    getVanpoolParticipants(history) {
      dispatch({ type: GET_VANPOOL_PARTICIPANTS, history })
    },
    setRefreshDashboard(refresh) {
      dispatch({ type: SET_REFRESH_DASHBOARD, refresh})
    },
    updateProfileData(){
      dispatch({type: UPDATE_USER_PROFILE_DATA});
    },
    resetRefreshSummaryAPI(value) {
      dispatch({type: RESET_REFRESH_SUMMARY_API, data: value});
    },
    loadProfileData() {
      dispatch({type: LOAD_PROFILE_AFTER_PERSONALINFO_UPDATE})
    },
    updateEnableNextbutton(data) {
      dispatch({ type: ENABLE_NEXT_BUTTON, data: data });
    }
  }
}

function mapStateToProps(state) {
  return {
    joinCommuteData: state?.joinCommute,
    vanInfoLoaded: state?.joinCommute?.vanInfoLoaded,
    participantsInfoLoaded: state?.joinCommute?.participantsInfoLoaded,
    uploadedImage: state?.joinCommute?.profile?.image,
    uploadErrorOccurred: state?.joinCommute?.profile?.uploadErrorOccurred,
    isPredelivery: state?.joinCommute?.selectedVan?.isPredelivery,
    employeeInfo: state?.profile?.employee,
    employeeIdUpdated: state?.joinCommute?.employeeIdUpdated,
    employeeIdUpdatedFailed: state?.joinCommute?.employeeIdUpdatedFailed,
    enableOnboardingNextButton: state?.joinCommute?.enableOnboardingNextButton
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingPage);